import { BlackServicesInactive } from '@assets/icons';
import SearchComponent from '@components/inputs/search/Search.component';
import { Colors } from '@constants/colors.constants';
import { Button, CircularProgress, Stack, Typography } from '@mui/material';
import { useObservable } from '@ngneat/react-rxjs';
import { auditsProposalSuppliersQuery } from '@store/audits/audit-offer-followUp/audit-proposal-suppliers/audit-proposal-suppliers.query';
import { auditProposalSuppliersServices } from '@store/audits/audit-offer-followUp/audit-proposal-suppliers/audit-proposal-suppliers.services';
import { OfferFollowUpDetailsRoutes } from '@utils/routes.utils';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { AuditOperation } from '../../../../store/audits/audits-operation/audits-operation.model';
import OfferContainerItem from './components/OfferContainerItem';
import ScrollingList from './components/ScrollingList';
interface DetailContainerProps {
    item: AuditOperation;
}

const DetailContainer = (props: DetailContainerProps) => {
    const { item } = props;
    const navigate = useNavigate();
    const { auditId } = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const [{ auditProposalSuppliers, loading }] = useObservable(auditsProposalSuppliersQuery.auditProposalSuppliers$);

    useEffect(() => {
        if (auditId && item.id) {
            auditProposalSuppliersServices.getAuditsProposal(auditId, undefined, undefined, item).subscribe({
                error: (err) => enqueueSnackbar(err.text, err.options)
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [item, auditId]);


    return (
        <Stack p="20px" height={'100%'} spacing={4}>
            <Stack spacing={2} pr={'10px'} direction="row" justifyContent="space-between" alignItems="center">
                <Stack direction="row" alignItems="center" spacing={1}>
                    <BlackServicesInactive style={{ height: 20, width: 20 }} />
                    <Typography color={Colors.black} fontWeight={700} fontSize='20px' textAlign='left'>
                        {item?.type == 'CUSTOM' ? item?.containerCustom : item?.container?.name}
                    </Typography>
                    <Typography color={Colors.lightGrey} fontWeight={700} fontSize='20px' textAlign='left'>
                        {item?.type == 'CUSTOM' ? item?.wasteCustom : item?.waste?.name}
                    </Typography>
                </Stack>
                <Button
                    variant="outlined"
                    color="primary"
                    disabled={false}
                    onClick={() => navigate(`details-container/${item?.id}`)}
                >
                    Voir le contenant
                </Button>
            </Stack>
            <SearchComponent
                isCustom
                value={''}
                handleChange={() => undefined}
                bgColor="#F4F6F8"
            />
            {loading ? (
                <Stack p="20px" height={'100%'} spacing={4} justifyContent={loading ? 'center' : undefined}>
                    <CircularProgress size={40} sx={{ alignSelf: 'center' }} />
                </Stack>
            ) : (
                <>
                    <ScrollingList height="100%" spacing={2}>
                        {auditProposalSuppliers
                            .sort((a, b) => new Date(a.createdAt) > new Date(b.createdAt) ? -1 : 1)
                            .map((it) => (
                                <OfferContainerItem key={it.id} item={it} handleClick={() => navigate(`${OfferFollowUpDetailsRoutes.DETAILS_OFFERSTATUS}/${it.id}`)} />
                            ))}
                    </ScrollingList>
                    <Outlet />
                </>
            )}
        </Stack >
    );
};


export default DetailContainer;